// @ts-nocheck
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { css } from "styled-components";

export const priceStyles = () => css`
    line-height: ${x => x.theme.design.typography.lineHeight.small};
`;

export const priceUnitOfMeasureStyles = () => css`
    position: relative;
    top: ${pxToRem(-1)};

    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smallest};
        font-weight: ${theme.design.typography.weight.base};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const priceSecondarySpacingStyles = () => css`
    ${spacingStyles(pxToRem(3), null)}
`;

export const priceVatLabelStyles = () => css`
    ${({ theme }) => css`
        display: block;
        font-size: ${theme.design.typography.size.tiny};
        font-weight: ${theme.design.typography.weight.bold};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;
